module.exports = __webpack_public_path__ + "static/media/BRONZE 2.f6968bdb.png";